// src/api/executionStateApi.ts
//
// RTK Query endpoint for the server Execution Engine projection. Additive: it
// injects one read-only query onto the shared baseApi (auth + workspace + refresh
// handled there; workspace is derived server-side from the token, so no param).
// The backend endpoint is gated by EXECUTION_ENGINE_ENABLED (404 when off).

import { baseApi } from './baseApi';
import type { ExecutionStateSnapshotDTO } from '../types/executionState';

export const executionStateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getExecutionState: builder.query<ExecutionStateSnapshotDTO, void>({
      query: () => ({ url: '/execution-state' }),
      providesTags: ['ExecutionState'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetExecutionStateQuery } = executionStateApi;
